import {Injectable, NgZone} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {SessionService} from './session.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../app/app.state';
import {AlarmsService} from './alarms.service';
import {UrlService} from './url.service';

@Injectable({
  providedIn: 'root',
})
export abstract class NativeService {
  protected constructor(
    protected http: HttpClient,
    protected session: SessionService,
    protected store: Store<AppState>,
    protected alarmsService: AlarmsService,
    protected urlService: UrlService,
    protected ngZone: NgZone,
  ) {
  }


  abstract hideSplash(): void;


  abstract runPushRegistration(): Observable<boolean>;


  abstract hideKeyboard(): void;


  abstract clipboardWrite(value: string);


  abstract isNativeSmartphone(): boolean;


  /**
   * Only is relevant for mobile apps
   */
  abstract hideStatusBar(): void;


  /**
   * Only is relevant for mobile apps
   */
  abstract showStatusBar(): void;
}
